import { Alert, FormGroup, FormLabel, Stack } from "@mui/material";
import { getWeekdayName } from "@sinch/utils/dateTime/format";
import { uniq, without } from "ramda";
import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import type { CreateIntervalFormData } from "@sinch/components/application/RateInterval/CreateInterval/formSchema";
import { StringTimeInput } from "@sinch/components/application/RateInterval/CreateInterval/StringTimeInput";
import { CheckboxInput } from "@sinch/components/form/CheckboxInput/CheckboxInput";
import { useMuiController } from "@sinch/components/index";

export const TimeIntervalSettings: FC = () => {
  const { t } = useTranslation();
  const { field: daysField } = useMuiController<CreateIntervalFormData, "settings.daysOfWeek">({
    name: "settings.daysOfWeek",
  });
  const { field: fromField } = useMuiController<CreateIntervalFormData, "settings.timeFrom">({
    name: "settings.timeFrom",
  });
  const { field: toField } = useMuiController<CreateIntervalFormData, "settings.timeTo">({
    name: "settings.timeTo",
  });
  const handleWeekdayChange = useCallback(
    (index: number, checked: boolean) => {
      daysField.onChange(checked ? uniq([index, ...daysField.value]) : without([index], daysField.value));
    },
    [daysField]
  );

  return (
    <Stack spacing={2}>
      <StringTimeInput {...fromField} label={t("RateUnit.timeFrom")} />
      <StringTimeInput {...toField} label={t("RateUnit.timeTo")} timePoint={fromField.value} />
      <FormGroup>
        <FormLabel>{t("RateUnit.weekdays")}</FormLabel>
        {Array.from({ length: 7 }, (_, i) => (
          <CheckboxInput
            key={i}
            {...daysField}
            label={getWeekdayName(i + 1)}
            onChange={(__, checked) => handleWeekdayChange(i + 1, checked)}
            value={daysField.value.includes(i + 1)}
          />
        ))}
      </FormGroup>
      <Alert severity="info" variant="outlined">
        {t("RateUnit.timeIntervalWeekdayBeginningAlert")}
      </Alert>
    </Stack>
  );
};
